import { render, staticRenderFns } from "./CreateViolationModal.vue?vue&type=template&id=ba97b05a&scoped=true"
import script from "./CreateViolationModal.vue?vue&type=script&lang=js"
export * from "./CreateViolationModal.vue?vue&type=script&lang=js"
import style0 from "./CreateViolationModal.vue?vue&type=style&index=0&id=ba97b05a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba97b05a",
  null
  
)

export default component.exports